import { render, staticRenderFns } from "./appointmentItem.vue?vue&type=template&id=0be86d0c&scoped=true"
import script from "./appointmentItem.vue?vue&type=script&lang=js"
export * from "./appointmentItem.vue?vue&type=script&lang=js"
import style0 from "./appointmentItem.vue?vue&type=style&index=0&id=0be86d0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be86d0c",
  null
  
)

export default component.exports